import React from 'react';
import { Rocket, Bot, Cloud, Cpu } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { servicesData } from '../data/mock';

const iconMap = {
  Rocket: Rocket,
  Bot: Bot,
  Cloud: Cloud,
  Cpu: Cpu
};

export const ServicesSection = () => {
  return (
    <section id="services" className="py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        {/* Section Title */}
        <h2 className="text-4xl sm:text-5xl font-extralight text-black mb-16 tracking-tight">
          {servicesData.title}
        </h2>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {servicesData.items.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="border-0 bg-gray-50 hover:bg-gray-100 transition-all duration-300 hover:-translate-y-1 group"
              >
                <CardContent className="p-8">
                  <div className="mb-6">
                    <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <IconComponent className="w-6 h-6 text-black" strokeWidth={1.5} />
                    </div>
                  </div>
                  <h3 className="text-xl font-normal text-black mb-3">
                    {service.title}
                  </h3>
                  <p className="text-gray-500 font-light leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
